"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiTypograpy = void 0;
exports.muiTypograpy = {
    defaultProps: {
        variantMapping: {
            'h1-large': 'h1',
            'h1-medium': 'h1',
        },
    },
};
//# sourceMappingURL=typography.js.map